// extracted by mini-css-extract-plugin
module.exports = {"seriesItem":"index_seriesItem__zwle1","active":"index_active__Dbd5Z"};